// [목적] 인증 페이지 한정 데스크톱 뷰포트 판별 훅 — 1024px 임계값 기준
// [이유] 기존 useViewport.ts 의 isDesktop 임계값은 1180px(메인 셸 기준).
//         인증 페이지 전용 분기 임계값(1024px, Spec §4-3, Q-10)을 격리하여
//         메인 셸 레이아웃과 인증 페이지 레이아웃의 분기점 불일치를 방지한다.
// [사이드 이팩트] MUI useMediaQuery 를 사용하므로 MUI ThemeProvider 컨텍스트 불필요
//                  (내부적으로 CSS 미디어쿼리 API 직접 구독 — SSR/PWA 정합 OK).
//                  resize 이벤트 리스너는 MUI 가 관리하므로 수동 cleanup 불필요.
// [수정 시 고려사항]
//   - 임계값 1024 는 Spec §8-1 Q-10 결정값. 변경 시 반드시 BrandVisualPanel/LoginDesktopLayout 와 동기화.
//   - 메인 셸(useViewport.ts)의 isDesktop(1180) 과 다름 — 의도적 격리 (R-9).
//   - 후속 admin 앱 또는 온보딩 페이지도 동일 임계값을 원하면 이 훅을 재사용할 것.
//   - packages/ui 이관 결정 시: 파일을 packages/ui/src/hooks/useIsDesktop.ts 로 이동 후 import 경로만 교체.

import { useMediaQuery } from '@mui/material';

/**
 * viewport 폭 >= 1024px 이면 true 를 반환한다.
 * 인증 페이지(LoginPage 등) 한정 레이아웃 분기에 사용한다.
 * 메인 셸의 isDesktop(≥1180) 과 혼용 금지.
 */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width:1024px)');
}
